import * as Rox from "rox-browser";

export const reports = {
  tax_report: new Rox.Flag(),
  delivery_ticket_report_v2: new Rox.Flag(),
  detailed_tickets_v2: new Rox.Flag(),
  searchable_location: new Rox.Flag(),
  searchable_customer_legal_entity: new Rox.Flag(),
  filter_locations_by_invoiced_status: new Rox.Flag(),
};
